module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testimonials container-fluid p-b-6",
    attrs: {
      "id": "testimonials"
    }
  }, [_c('section', {
    staticClass: "section team-section"
  }, [_c('h1', {
    staticClass: "section-heading"
  }, [_vm._v(_vm._s(_vm.t('What others are saying')))]), _vm._v(" "), _c('div', {
    staticClass: "row text-xs-center sameHeight"
  }, [_c('Card', {
    staticClass: "card"
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "videoContainer image",
    staticStyle: {
      "padding-bottom": "65%"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/uinHxDRBfGI?rel=0",
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": ""
    }
  })], 1)])]), _vm._v(" "), _c('Card', {
    staticClass: "card"
  }, [_c('div', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "width": "150",
      "src": "/static/img/logo-uniplanet.png",
      "alt": "Uniplanet"
    }
  })]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('p', [_vm._v("(" + _vm._s(_vm.t('Interview')) + ")")]), _vm._v(" "), _c('p', [_vm._v("\"" + _vm._s(_vm.t('Booknatura is a new booking platform for outdoor activities that provide the contact with nature in Portugal')) + "\".")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.theuniplanet.com/2018/06/todas-atividades-ar-livre-portugal-booknatura.html",
      "target": "_blank"
    }
  }, [_vm._v("theuniplanet.com/2018/06/todas...")])])])]), _vm._v(" "), _c('Card', {
    staticClass: "card"
  }, [_c('div', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "width": "70",
      "src": "/static/img/logo-nit-cat-out-of-town.png",
      "alt": "logo nit"
    }
  })]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('p', [_vm._v("\n          \"" + _vm._s(_vm.t('From jeep tours to scuba diving and dolphin watching: on this new platform you can book everything')) + ".\"\n          \"De passeios de jipe a fazer mergulho e ver golfinhos: nesta nova plataforma pode reservar tudo.\"\n          ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://nit.pt/out-of-town/se-gosta-de-atividades-ao-ar-livre-tem-de-conhecer-esta-nova-plataforma-online",
      "target": "_blank"
    }
  }, [_vm._v("nit.pt/out-of-town/se-gosta-de-ativid...")])])])]), _vm._v(" "), _c('Card', {
    staticClass: "card"
  }, [_c('div', {
    slot: "title"
  }, [_vm._v("Blog Uma Susana no Mundo")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('p', [_vm._v("\n          \"" + _vm._s(_vm.t('Use booknatura.com to find out more about outdoor activities for yourself, friends and family')) + ".\"\n          ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://umasusananomundo.wordpress.com/2018/06/22/booknatura-com/",
      "target": "_blank"
    }
  }, [_vm._v("umasusananomundo.wordpress.com/...")])])])]), _vm._v(" "), _c('Card', [_c('div', {
    slot: "title"
  }, [_vm._v("\n          Elsa M.\n        ")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("\n          \"" + _vm._s(_vm.t('I did with my husband the Horse Carriage Tour in Alentejo Coast. In addition to the bamboos we had the opportunity to stroll along a stream in a typical Alentejo landscape. Very beautiful landscapes and very friendly and accessible guide. I recommend the tour and the Booknatura service')) + ".\"\n        ")])]), _vm._v(" "), _c('Card', [_c('div', {
    slot: "title"
  }, [_vm._v("\n          Joana P.\n        ")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("\n          \"" + _vm._s(_vm.t('Booknatura was a nice surprise! Practical, fast, easy and very efficient. I advise everyone who enjoys this type of activities to book through Booknatura. It was a great experience, to repeat!')) + ".\"\n        ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e88ccaa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e88ccaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Testimonials.vue
// module id = 767
// module chunks = 3